<div *ngxPermissionsOnly="[Permission.NITEL_IQ_PARTICIPANT]">
  <app-overall-network-status-page />
</div>

<div *ngxPermissionsExcept="[Permission.NITEL_IQ_PARTICIPANT]">
  <section class="dashboard" [ngClass]="browserSize">
    <div class="widgets-container mx-auto max-w-7xl p-5 md:px-8">
      <div class="row short">
        <app-dashboard-widget
          class="widget-all widget-left"
          [widgetType]="widgetTypes.SUMMARY.label"
          >Summary</app-dashboard-widget
        >
        @if ((orionUrl$ | async)?.length) {
          <app-dashboard-widget
            class="widget-all widget-wide monitoring-container"
            [widgetType]="widgetTypes.MONITORING.label"
            *ngxPermissionsOnly="Permission.MONITORING"
            >Monitoring</app-dashboard-widget
          >
        }
      </div>
      <div class="row tall">
        <app-dashboard-widget
          class="widget-all widget-standard"
          [widgetType]="widgetTypes.BILLING.label"
          *ngxPermissionsOnly="Permission.BILLING_READ"
          >Billing</app-dashboard-widget
        >
        <app-dashboard-widget
          class="widget-all widget-standard"
          [widgetType]="widgetTypes.TICKETING.label"
          *ngxPermissionsOnly="Permission.TICKETING_READ"
          >Tickets</app-dashboard-widget
        >
        <app-dashboard-widget
          class="widget-all widget-standard"
          [widgetType]="widgetTypes.ORDERS.label"
          *ngxPermissionsOnly="Permission.ORDERS"
          >Orders</app-dashboard-widget
        >
        <app-dashboard-widget
          class="widget-all widget-standard"
          [widgetType]="widgetTypes.SERVICES.label"
          *ngxPermissionsOnly="Permission.SERVICES"
          >Services</app-dashboard-widget
        >
      </div>
    </div>
  </section>
</div>

